import { useMutation } from "@apollo/react-hooks";
import { useAsyncCallback } from 'react-use-async-callback';
import gql from "graphql-tag";
import { AsyncActionStatus } from '../../../shared/abstractStore';
import { QuestionnaireRespondentSessionUpdateInput } from '../generated/globalTypes';
import { updateQuestionnaireRespondentSessionMutation, updateQuestionnaireRespondentSessionMutationVariables } from '../generated/updateQuestionnaireRespondentSessionMutation';
import { questionnaireRespondentSessionFieldsFragment } from '../models/QuestionnaireRespondentSession';

/**
 * Get a callback to update a QuestionnaireRespondentSession in the store.
 */
export function useUpdateQuestionnaireRespondentSessionCallback(): [(id: string, model: QuestionnaireRespondentSessionUpdateInput) => Promise<void>, AsyncActionStatus] {
    const [mutationAction, { error }] = useMutation<updateQuestionnaireRespondentSessionMutation, updateQuestionnaireRespondentSessionMutationVariables>(
        gql`
            mutation updateQuestionnaireRespondentSessionMutation ($model: QuestionnaireRespondentSessionUpdateInput!) {
                updateQuestionnaireRespondentSession(model: $model) {
                    ...questionnaireRespondentSessionFields
                }
            }

            ${questionnaireRespondentSessionFieldsFragment}
        `
    );

    // Wrap the mutation in a standard callback.
    const [action, { isExecuting, errors: actionErrors }] = useAsyncCallback(async (id: string, model: QuestionnaireRespondentSessionUpdateInput) => {
        const result = await mutationAction({ variables: { model: { ...model, id: id } } });
        if (result.errors && result.errors.length) {
            throw result.errors;
        }
    }, [mutationAction]);

    return [action, { isExecuting: isExecuting, errors: error ? error.message : actionErrors }];
}
